

<div class="flex flex-col sm:h-full sm:flex-row items-center">
    <div class="sm:w-3/5 sm:h-full w-full
        h-1/2 grid place-content-center
        bg-emerald-50 ">
        <landing-screen class="p-6 sm:p-32"></landing-screen>
    </div>

    <div class="ie-fix sm:w-2/5
        sm:h-full w-full h-1/2 px-10 grid place-items-center">
        <form [formGroup]="forgotPasswordFormGroup" class="p-6 sm:p-32">
            <p class="text-3xl sm:text-4xl leading-loose font-bold
                text-red-500">Forgot Password?</p>
            <p class="text-[24-px] sm:text-[36-px] leading-relaxed font-bold">To
                receive a temporary
                password
                reset link, enter
                the email used to set up your account. Be aware the
                temporary password reset link will come from
                <a class="text-green-600"
                    href="mailto:contributions@lge-ku.com">contributions@lge-ku.com</a>.
                Please open the link on that email to reset your password.
            </p>
            <mat-form-field appearance="outline">
                <input type="text" matInput placeholder="Email"
                    formControlName="email">
            </mat-form-field>
            <div fxLayout="column" fxLayoutAlign="center center">
                <button mat-raised-button (click)="sendLink()"
                    [disabled]="forgotPasswordFormGroup.invalid"
                    class="login-button" color="primary">Send Link</button>
            </div>
            <br>
        </form>
    </div>

</div>